var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.881,
    height: 15.27,
    viewBox: "0 0 13.881 15.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1697",
    "data-name": "Trazado 1697",
    d: "M8.941,13.493a.694.694,0,1,0-.694-.694A.694.694,0,0,0,8.941,13.493Zm3.47,0a.694.694,0,1,0-.694-.694A.694.694,0,0,0,12.411,13.493Zm0-2.776a.694.694,0,1,0-.694-.694A.694.694,0,0,0,12.411,10.717Zm-3.47,0a.694.694,0,1,0-.694-.694A.694.694,0,0,0,8.941,10.717ZM13.8,2.388h-.694V1.694a.694.694,0,0,0-1.388,0v.694H6.164V1.694a.694.694,0,1,0-1.388,0v.694H4.082A2.082,2.082,0,0,0,2,4.47v9.717A2.082,2.082,0,0,0,4.082,16.27H13.8a2.082,2.082,0,0,0,2.082-2.082V4.47A2.082,2.082,0,0,0,13.8,2.388Zm.694,11.8a.694.694,0,0,1-.694.694H4.082a.694.694,0,0,1-.694-.694V7.941H14.493Zm0-7.635H3.388V4.47a.694.694,0,0,1,.694-.694h.694V4.47a.694.694,0,0,0,1.388,0V3.776h5.553V4.47a.694.694,0,0,0,1.388,0V3.776H13.8a.694.694,0,0,1,.694.694ZM5.47,10.717a.694.694,0,1,0-.694-.694A.694.694,0,0,0,5.47,10.717Zm0,2.776a.694.694,0,1,0-.694-.694A.694.694,0,0,0,5.47,13.493Z",
    transform: "translate(-2 -1)",
    fill: "#e73758"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.0d8cd5a28f4551a9f465e11a931a1c56.svg";
export { ForwardRef as ReactComponent };